import { DataClassifiers } from '@ariksa/data-scanning/api';

import { normalizeDataTypes } from 'components/DataDisplay/DataType/utils';

// Can-access-data rows carry only data type names (data_type_tags), so derive
// the row's data labels (e.g. PII, PCI) from the matching classifiers, in the
// order they first appear and without duplicates.
export const getDataLabelsForDataTypes = (
  dataTypes: unknown,
  classifiers: DataClassifiers[] = [],
): string[] => {
  const labelsByDataType: Record<string, string[]> = {};
  classifiers.forEach(classifier => {
    const [name] = normalizeDataTypes(classifier);
    if (name) labelsByDataType[name] = Array.from(classifier.labels ?? []);
  });

  const labels = normalizeDataTypes(dataTypes).flatMap(
    dataType => labelsByDataType[dataType] ?? [],
  );
  return Array.from(new Set(labels));
};
